import { jsx as i } from "react/jsx-runtime";
import { createContext as f, useState as y, useContext as T, useEffect as g } from "react";
import v from "../../utils/camelToCustomProperty.js";
import '../../index.css';/* empty css                   */
const x = (e) => {
  const t = {};
  return Object.entries(e ?? {}).forEach(([s, o]) => {
    o !== void 0 && (t[v(s)] = o);
  }), t;
}, C = (e, t) => e === "system" ? t ? "dark-mode" : "light-mode" : `${e}-mode`, h = f({ mode: "light", tokens: {} }), M = (e) => {
  const { children: t, mode: s, tokens: o } = e, [k, m] = y(!1), r = T(h), a = s ?? r?.mode ?? "light", c = o ? { ...r?.tokens, ...o } : r?.tokens ?? {}, p = x(c), l = C(a, k);
  return g(() => {
    const n = window?.matchMedia?.("(prefers-color-scheme: dark)");
    m(!!n?.matches);
    const d = (u) => m(u.matches);
    return n?.addEventListener("change", d), () => n?.removeEventListener("change", d);
  }, []), /* @__PURE__ */ i(h.Provider, { value: { mode: a, tokens: c }, children: /* @__PURE__ */ i(
    "div",
    {
      "data-market-theme": l,
      style: { display: "contents", ...p },
      children: t
    }
  ) });
};
M.displayName = "MarketTheme";
export {
  M as MarketTheme
};
